import React from 'react'

import { ButtonSelector } from '@masfront/common-b2c'

import { Box, Divider, Card, Button, Typography, Collapse } from '@material-ui/core'

import useSaleConfigurator from './useSaleConfigurator'

export default function SaleConfigurator() {
  const {
    techButtonsFormatted,
    lineTypeButtonsFormatted,
    productButtonsFormatted,
    shouldDisable,
    shouldShowLineType,
    onStartSale,
    updateStateKey,
    onSetProduct,
    onSetTechnology,
    technology,
    lineType,
    product,
  } = useSaleConfigurator()

  return (
    <>
      <Box component={Card} borderRadius="14px">
        <Box py="20px" px="24px">
          <Typography variant="h3">Configuración de venta</Typography>
        </Box>
        <Divider />
        <Box mt="24px" mb="32px">
          <Box px="24px">
            <Box mb="28px" mt="24px">
              <ButtonSelector
                onSelect={(value: string) => onSetTechnology('technology', value)}
                buttons={techButtonsFormatted}
                title="Selecciona el tipo de venta que vas a realizar…"
                shouldReset={!technology}
              />
            </Box>
            <Divider className="dashed" />
            <Collapse in={shouldShowLineType}>
              <Box mb="28px" mt="24px" px="0">
                <ButtonSelector
                  onSelect={(value: string) => updateStateKey('lineType', value)}
                  buttons={lineTypeButtonsFormatted}
                  title="¿Qué tipo de línea vas a crear?"
                  shouldReset={!lineType}
                />
              </Box>
              <Divider className="dashed" />
            </Collapse>
            <Box mb="28px" mt="24px" px="0">
              <ButtonSelector
                onSelect={(value: string) => onSetProduct('product', value)}
                buttons={productButtonsFormatted}
                title="… y el tipo de producto"
                shouldReset={!product}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box mt="24px">
        <Button
          onClick={onStartSale}
          disabled={shouldDisable}
          variant="contained"
          color="secondary"
          size="medium"
          data-hook="start-sale"
        >
          Comenzar Venta
        </Button>
      </Box>
    </>
  )
}
